import Chip from './Chip'

export * from './Chip'

export default Chip
